// TODO: delete this component, it is not working correctly and not used at this moment

import { Component, OnInit } from '@angular/core';

import { BcMessagesManager } from '../../../widgets';
import {
  RegistrationService,
  SettingsService,
  SigningService,
  SurveysService,
  TenantService,
  ValidationStatuses
} from '../../services';
import { ProcessorsService } from '../../../custodian/processors.service';

import { KYCStatusCodes } from '../../../shared/models/kycStatus.enum';

export enum DashboardNotificationStatus {
  NotStarted = 'reg_not_started',
  InProgress = 'reg_in_progress',
  KYCExpired = 'kyc_expired',
  WaitingSigning = 'waiting_signing',
  SigningInProgress = 'signing_in_progress',
  SigningCompleted = 'signing_complete'
}

export enum KYCStatuses {
  NotAvailable,
  InProgress,
  Submited,
  Expired
}

@Component({
  selector: 'bc-dashboard-status',
  templateUrl: './dashboard-status.component.html',
  styleUrls: ['./dashboard-status.component.scss']
})
export class DashboardStatusComponent implements OnInit {
  dashboardPopupStatus: DashboardNotificationStatus;

  completedCustodian: boolean;

  statuses = DashboardNotificationStatus;

  statusHidden = true;

  tenantName: string;

  constructor(public registrationService: RegistrationService,
              private processorsService: ProcessorsService,
              private signingService: SigningService,
              private settingsService: SettingsService,
              private tenantService: TenantService,
              private surveysService: SurveysService,
              public bcMessagesManager: BcMessagesManager) { }

  ngOnInit() {
    this.tenantService.resolve().then(({ tenantName }) => this.tenantName = tenantName);
  }

  checkStatus() {
    this.getDashboardStatus().then((status: DashboardNotificationStatus) => {
      const lastShownStatus = sessionStorage.getItem('lastDashboardMessage');
      this.dashboardPopupStatus = status;
      this.statusHidden = lastShownStatus === this.dashboardPopupStatus;
    });
  }

  close() {
    this.statusHidden = true;
    sessionStorage.setItem('lastDashboardMessage', this.dashboardPopupStatus);
  }

  async getDashboardStatus(): Promise<DashboardNotificationStatus> {
    if (this.getKYCStatus() === KYCStatuses.Expired) return DashboardNotificationStatus.KYCExpired;

    const surveyCompleted = await this.isSurveyCompleted();
    const kycCompleted = this.getKYCStatus() === KYCStatuses.Submited;

    const regDoneInUI = surveyCompleted && kycCompleted && this.completedCustodian &&
      (this.registrationService.isRegistrationDoneInUI() || this.registrationService.isRegistrationComplete);

    if (regDoneInUI) {
      if (!this.registrationService.isSigningStarted) return DashboardNotificationStatus.WaitingSigning;

      // TODO this definitely incorrect, we need to improve it!?
      const signingStatus: ValidationStatuses = await this.signingService.getSigningStatus().toPromise();

      return (signingStatus === ValidationStatuses.Done) ?
        DashboardNotificationStatus.SigningCompleted :
        DashboardNotificationStatus.SigningInProgress;
    }

    // if (this.registrationService.isAnyPartyStarted()) resolve(DashboardNotificationStatus.InProgress);

    return DashboardNotificationStatus.NotStarted;
  }

  isSurveyCompleted() {
    return this.surveysService.getSurveySettings(this.registrationService.registrationId).then(({ surveyEnabled }) => {
      if (!surveyEnabled) return true;

      const survey = this.registrationService.survey;
      const surveySubmittedStatusCode = 10;

      return survey && survey.status.code === surveySubmittedStatusCode;
    });
  }

  getKYCStatus() {
    if (!this.settingsService.kycSurveySettingEnable) return KYCStatuses.NotAvailable;

    if (!this.registrationService.kyc) return KYCStatuses.InProgress;

    if (this.registrationService.kyc.status.code === KYCStatusCodes.Expired) return KYCStatuses.Expired;

    if (this.registrationService.kyc.status.code === KYCStatusCodes.Submitted ||
      this.registrationService.kyc.status.code === KYCStatusCodes.SubmittedWithWarnings ||
      this.registrationService.kyc.status.code === KYCStatusCodes.Rejected)return KYCStatuses.Submited;
  }
}
